import { getAugmentedSchema, useFormAugmentedContext } from '@framework/form';
import { ArraySchema } from '@framework/validation';
import { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

/**
 * Hook che restituisce una funzione per il calcolo del valore di default delle righe
 * di un widget lista ripetibile. Il valore di default è calcolato in base allo schema
 * andandolo a prendere attraverso le funzione `getAugmentedSchema` in modo similare
 * a quanto fatto in `useField`.
 *
 * Non riuscendo ad estrarre il validatore _della singola riga_ ma solo dell'intero array,
 * aggiriamo il problema castando a un array di singolo elemento e poi estraendo l'elemento
 * stesso.
 *
 */
export function useGetRepeatableChildrenDefault(name: string) {
  const augmented = useFormAugmentedContext();
  const methods = useFormContext();
  const listSchema = useMemo(
    () => getAugmentedSchema(augmented, methods.getValues(), name),
    [augmented, methods, name],
  );

  // Essendo un arraySchema, vado a recuperare lo schema degli elementi interni per calcolare il default
  const getDefault = useCallback(() => {
    if (listSchema instanceof ArraySchema) {
      return listSchema.innerType?.cast({}, { assert: false }) ?? null;
    }
    return null;
  }, [listSchema]);

  return getDefault;
}
